module.exports = __webpack_public_path__ + "static/media/DOPIBOJ_baseline_diagnostics.9eed77de.png";